import React, { useState, useRef } from "react";
import * as RB from "react-bootstrap";
import "../pages/InvestigationPage.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faExclamationCircle } from "@fortawesome/free-solid-svg-icons";

export const ProgressBar = (props) => {
    const [showModal, setShowModal] = useState(false);

    /*
    status has the following scheme:
    {
        status: Int; Possible values: 
            0 - queued,
            1 - in progress, 
            2 - Done, 
            3 - error, 
            4 - cancelled
        error: String
        progress: Array [float,float,String,String]
    }
    */
    /**@type {Object} */
    const status = props.status;
    if (status == null) {
        return <></>;
    }
    let progress = null;
    let now = 0;
    let info = "";
    let tStatus = status["status"];
    let errInfo = status["error"];
    let result = status["result"];
    let tooltip = null;
    try {
        if (errInfo !== "") {
            let errObj = JSON.parse(errInfo);
            errInfo = errObj["err_info"];
            console.log(errObj["log"]);
        }
    } catch (e) {
        console.log(e);
    }
    if (status["progress"] !== "") {
        // progress = JSON.parse(status["progress"]);
        progress = status["progress"];
        now = ((progress[0] / progress[1]) * 100).toFixed(0);
        info = progress[2];
    }
    if (tStatus === 0) {
        info = "В очереди";
    } else if (tStatus === 1) {
        // If task status equals 1 (in progress) but received progress is empty
        // that means backend already send task to ProcessPoolExevutor but there are no
        // available workers to complete the task
        info =
            status["progress"] == "" && status["msgCount"] > 3
                ? "Исполняется другая задача"
                : info;
    } else if (tStatus === 2) {
        info = "Выполнено";
        if (
            result["meta"] !== undefined &&
            result["meta"]["mark_prob"] !== undefined
        ) {
            let mark_prob = (
                status["result"]["meta"]["mark_prob"] * 100
            ).toFixed(0);
            info += " (присутствие ЦВЗ - " + mark_prob + "%)";
            tooltip =
                "Оценка вероятности наличия цифрового водяного знака в изображении документа";
        }
        now = 100;
    } else if (tStatus === 3) {
        info = "Ошибка";
        console.log(errInfo);
        now = 0;
    } else if (tStatus === 4) {
        info = "Отменена";
        // console.log(errInfo);
        now = 0;
    } else if (tStatus === 10) {
        info = "Идет отправка запроса";
        now = 0;
    }

    return (
        <div id="progress-status-div">
            <div id="progress-bar-div">
                <p id="progress-bar-perc">{now}%</p>
                <RB.ProgressBar id="progress-bar-bar" now={now}>
                    {/* <div className="progress-bar-text">30%</div> */}
                </RB.ProgressBar>
            </div>
            <div
                id="progress-status-info-div"
                title={tooltip}
                style={{ cursor: tooltip === null ? "auto" : "help" }}
            >
                {errInfo !== "" && (
                    <FontAwesomeIcon
                        id="progress-status-info-error"
                        icon={faExclamationCircle}
                        color="red"
                        title="Нажмите, чтобы увидеть информацию об ошибке"
                        onClick={() => {
                            setShowModal(true);
                        }}
                    ></FontAwesomeIcon>
                )}
                <p id="progress-status-info">{info}</p>
            </div>
            <RB.Modal
                show={showModal}
                onHide={() => {
                    setShowModal(false);
                }}
                size={"lg"}
            >
                <RB.Modal.Header closeButton>
                    <RB.Modal.Title>Информация об ошибке</RB.Modal.Title>
                </RB.Modal.Header>
                <RB.Modal.Body>
                    <pre>{errInfo}</pre>
                </RB.Modal.Body>
            </RB.Modal>
        </div>
    );
};
